import { Component, HostListener, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { EventconfigStoreService } from '../../shared/eventconfig-store.service';
import { PlayerStoreService } from '../../shared/player-store.service';
import { Question } from '../../shared/question';
import videojs from 'video.js';

@Component({
    selector: 'lse-vod-question-list-item',
    templateUrl: './vod-question-list-item.component.html',
    styleUrls: ['./vod-question-list-item.component.css'],
    standalone: false
})
export class VodQuestionListItemComponent implements OnInit {
  @Input() question: Question;
  @Input() nextQuestionVideoTime: number;
  @Output() myEvent = new EventEmitter();
  @Output() changeManualPageChangeFalse = new EventEmitter();

  questionTxt: string;
  screenwidth = document.body.offsetWidth;
  tcStart: number;
  highlight = false;
  player;
  language:string;
  constructor(
    private es: EventconfigStoreService,
    private vs: PlayerStoreService
  ) {}

  ngOnInit(): void {
    this.language = this.es.getActiveLang();
    this.tcStart = this.question.videoTime[this.language] ;
    this.questionTxt = this.question.txt_raw;
    if ( this.language === 'de') {
      this.questionTxt = this.question.txt_de;

    } else if ( this.language === 'en') {
      this.questionTxt = this.question.txt_en;
    }
    else if ( this.language === 'nl') {
      this.questionTxt = this.question.txt_nl;
    }
    else if ( this.language === 'pt') {
      this.questionTxt = this.question.txt_pt;
    }
    else if ( this.language === 'es') {
      this.questionTxt = this.question.txt_es;
    }
    else if ( this.language === 'cn') {
      this.questionTxt = this.question.txt_cn;
    }
    else if ( this.language === 'jp') {
      this.questionTxt = this.question.txt_jp;
    }
    else {
      this.questionTxt = this.question.txt_raw;
    }
    this.highlightQuestion();
    this.player = this.vs.getPlayer();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenwidth = window.innerWidth;
  }
  clickQuestion() {
    this.myEvent.emit(this.question.videoTime[this.language] );
    setTimeout(()=>{
      this.changeManualPageChangeFalse.emit();
  }, 1000);
  }
  highlightQuestion() {
    setInterval(() => {
      let playTime = this.vs.getCurrentPlayTime();
      if (playTime >= this.tcStart && playTime < this.nextQuestionVideoTime) {
        this.highlight = true;
        // console.log('if ' + playTime + ' ' + this.tcEnd);
      } else {
        this.highlight = false;
        // console.log('else ' + playTime + ' ' + this.tcEnd);
      }
    }, 500);
  }

  getTcSecond(tc: string): number {
    let hms = tc;
    let a = hms.split(':');
    let seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    return seconds;
  }
}
